import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect, isNative } from '@bubble-ui/util-platform';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
export var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var designContext = _ref.designContext,
    designVersion = _ref.designVersion,
    doubleMonth = _ref.doubleMonth,
    inline = _ref.inline,
    presets = _ref.presets;
  var borderRadius = designContext.get('date-picker/corner-radius').pixelValue;
  return {
    rootStyle: doubleMonth ? {
      flexDirection: 'column',
      width: 320
    } : inline ? _objectSpread({
      width: '100%'
    }, presets ? platformSelect({
      web: {
        flexDirection: 'row'
      },
      default: {
        maxWidth: 420
      }
    }) : {
      maxWidth: 420
    }) : _objectSpread(_objectSpread({}, platformSelect({
      web: {
        boxShadow: "".concat(Colors.__shadowMedium(designVersion).toString(), " 0 3px 15px 0px")
      },
      default: {}
    })), {}, {
      backgroundColor: designContext.get('date-picker/background-color').toString(),
      borderRadius: borderRadius
    }, presets ? platformSelect({
      web: {
        alignSelf: 'end',
        display: 'inline-flex',
        flexDirection: 'row'
      },
      default: {
        width: 320
      }
    }) : {
      flexDirection: 'column',
      width: 320
    }),
    calendarContainerStyle: {
      flexDirection: 'column',
      paddingTop: 10
    },
    monthStyle: {
      paddingBottom: 15,
      paddingLeft: inline ? 0 : 20,
      paddingRight: inline ? 0 : 20
    },
    weekDayStyle: {
      flexDirection: 'row',
      paddingBottom: 0
    },
    monthDayStyle: {
      flexDirection: 'row',
      paddingBottom: 5
    },
    presetContainerStyle: {
      alignItems: 'flex-start',
      backgroundColor: designContext.get('date-picker/preset-background-color').toString(),
      borderBottomRightRadius: borderRadius,
      borderTopRightRadius: borderRadius,
      borderBottomLeftRadius: isNative ? borderRadius : 0,
      borderTopLeftRadius: isNative ? borderRadius : 0,
      marginLeft: isNative ? 20 : 0,
      marginRight: isNative ? 20 : 0,
      justifyContent: 'center',
      paddingLeft: 15,
      paddingRight: 15,
      paddingBottom: 10,
      paddingTop: 10,
      position: 'relative',
      right: 0
    },
    spacerVerticalExtraSmallStyle: {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      width: '100%',
      height: 10
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map